/**
 * Atlas PM · 操作日志 · 数据 hooks
 *
 * 缓存 key 统一走 qk.auditLogs(params)（api/queryKeys.ts），
 * 便于任务详情抽屉等其它操作日志查询复用失效。
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { qk } from '../../api/queryKeys';
import {
  fetchAuditLogs,
  fetchAuditVerify,
  type AuditLogsResult,
  type AuditQueryParams,
  type AuditVerifyResult,
} from './api';

/**
 * 操作流（分页 / 过滤）。
 *
 * keepPreviousData：翻页 / 改筛选时保留上一页数据，避免表格闪空。
 */
export function useAuditLogs(params: AuditQueryParams) {
  return useQuery<AuditLogsResult>({
    queryKey: [...qk.auditLogs(params), 'page'] as const,
    queryFn: () => fetchAuditLogs(params),
    placeholderData: keepPreviousData,
  });
}

/**
 * 哈希链完整性校验。
 *
 * ⚠️ 该接口会对全表逐条重算哈希（当前约 3000+ 行），是「能证明数据没被改过」
 *    的核心能力，进入页面即自动执行一次；手动点「重新校验」可强制刷新。
 */
export function useAuditVerify() {
  return useQuery<AuditVerifyResult>({
    queryKey: qk.auditVerify(),
    queryFn: fetchAuditVerify,
    staleTime: 0,
  });
}
